import React from 'react'
import { Stack, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { BasicModal } from '../BasicModal'
import { CANCEL_BTN_ATTRIBUTES, SUBMIT_MODAL_ATTRIBUTES, SUBMIT_TEST_BTN_ATTRIBUTES } from '@app/constants'
import { formatDuration } from './helpers'
import { AssessmentStatus } from '@app/firebase/api'
import { getReturnButtonText } from '@app/helpers'
import { getTerm } from '@app/helpers/workkeysReplaceTerms'

type Props = {
  open: boolean
  onClose: () => void
  onSubmit: () => void
  title: string
  itemsCount: number
  duration: number
  status: AssessmentStatus
  origin?: string
}

const testTerm = getTerm('Test', true)
const testTermLower = getTerm('test')

export const StartTestModal: React.FC<Props> = ({
  open,
  onClose,
  onSubmit,
  title,
  itemsCount,
  duration = 0,
  status,
  origin,
}) => {
  const startTest = status === AssessmentStatus.new ? true : false

  return (
    <BasicModal
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      size='sm'
      title={`You are about to ${startTest ? 'start' : 'continue'} the ${title}`}
      submitText={startTest ? `Start ${testTerm}` : `Continue ${testTerm}`}
      cancelText={getReturnButtonText(origin)}
      modalProps={SUBMIT_MODAL_ATTRIBUTES}
      submitButtonProps={{
        ...SUBMIT_TEST_BTN_ATTRIBUTES,
        endIcon: <FontAwesomeIcon size='sm' icon={faArrowRight} aria-hidden='true' />,
      }}
      cancelButtonProps={CANCEL_BTN_ATTRIBUTES}
    >
      {/*
        a11y: Use plain inline <b> (not nested Typography) and collapse
        interpolated variables into single template-literal expressions so NVDA
        reads each sentence as one continuous sentence — each JSX {expression}
        becomes its own DOM text node, which fragments screen-reader output.
      */}
      <Stack gap={6}>
        <Typography variant='variation_subtitle1' component='p'>
          You are going to answer <b>{itemsCount}</b> questions.
        </Typography>
        {duration === 0 ? (
          <Typography variant='variation_subtitle1' component='p'>
            {`This ${testTermLower} is `}<b>untimed</b>{`. You can leave the ${testTermLower} at any time. Your progress will be saved.`}
          </Typography>
        ) : (
          <Typography variant='variation_subtitle1' component='p'>
            {'You will have '}<b>{formatDuration(duration)}</b>{` to complete the ${testTermLower}. You can leave the ${testTermLower} at any time. Your progress will be saved.`}
          </Typography>
        )}
      </Stack>
    </BasicModal>
  )
}
